const translations = {
    en: {
        language: {
            current: 'EN',
            changeTo: 'ES',
            label: 'Change language to Spanish'
        },

        navigation: {
            home: 'Home',
            about: 'About Us',
            services: 'Services',
            projects: 'Our Work',
            process: 'Our Process',
            area: 'Service Area',
            contact: 'Contact',
            estimate: 'Get a Free Estimate'
        },

        hero: {
            eyebrow: 'Concrete built with purpose',
            titleFirst: 'Your vision.',
            titleSecond: 'Built to last.',
            description:
                'Professional residential and commercial concrete solutions across North Mississippi—delivered with care, clarity, and craftsmanship.',
            estimate: 'Get a Free Estimate',
            projects: 'Explore Our Work',
            trust: [
                'Residential & Commercial',
                'Free Project Estimates',
                'Quality Workmanship',
                'North Mississippi Service'
            ]
        },

        about: {
            section: 'About MMP Concrete LLC',
            eyebrow: 'Solid work. Straight answers.',
            titleFirst: 'Concrete work built around',
            titleSecond: 'your vision.',
            paragraphOne:
                'MMP Concrete LLC provides dependable residential and commercial concrete solutions throughout North Mississippi. From a simple walkway to a commercial floor, we approach every project with the same attention to detail.',
            paragraphTwo:
                'Our goal is simple: understand what you need, prepare the job correctly, and deliver a strong, clean finish you can feel confident about.'
        },

        mission: {
            eyebrow: 'Our Mission',
            titleFirst: 'Build it right.',
            titleSecond: 'Treat people right.',
            values: [
                {
                    title: 'Craftsmanship',
                    description:
                        'Careful preparation and attention to the details that shape a lasting result.'
                },
                {
                    title: 'Communication',
                    description:
                        'Clear expectations and straightforward updates from estimate to final review.'
                },
                {
                    title: 'Reliability',
                    description:
                        'A professional approach focused on your property, schedule, and project goals.'
                }
            ]
        },

        services: {
            section: 'What We Build',
            eyebrow: 'Our Services',
            titleFirst: 'From the first pour to the',
            titleSecond: 'final finish.',
            description:
                'Practical concrete solutions for homes, businesses, and custom projects of all sizes.',
            action: 'Discuss Your Project',
            items: [
                {
                    title: 'Driveways',
                    description:
                        'Clean, durable entrances designed for everyday use and lasting curb appeal.'
                },
                {
                    title: 'Patios',
                    description:
                        'Outdoor spaces designed for gatherings, quiet mornings, and everyday enjoyment.'
                },
                {
                    title: 'Walkways & Sidewalks',
                    description:
                        'Safe and professionally finished paths that connect your property with purpose.'
                },
                {
                    title: 'Concrete Slabs',
                    description:
                        'Precisely prepared slabs for sheds, shops, additions, and custom construction.'
                },
                {
                    title: 'Commercial Floors',
                    description:
                        'Professional concrete solutions built around demanding commercial needs.'
                },
                {
                    title: 'Custom Concrete',
                    description:
                        'A practical and tailored approach for projects that do not fit a standard mold.'
                }
            ]
        },

        projects: {
            section: 'Selected Projects',
            eyebrow: 'Built in the Real World',
            titleFirst: 'Work that speaks',
            titleSecond: 'for itself.',
            description:
                'Explore a selection of the range, finish, and care we bring to every concrete project.',
            filters: {
                all: 'All',
                driveways: 'Driveways',
                patios: 'Patios',
                sidewalks: 'Sidewalks',
                slabs: 'Slabs',
                commercial: 'Commercial',
                other: 'Other'
            },
            viewProject: 'View Project',
            close: 'Close',
            empty:
                'No projects are currently available in this category.'
        },

        process: {
            section: 'Our Process',
            eyebrow: 'Clear from Day One',
            titleFirst: 'A straightforward path from idea to',
            titleSecond: 'finished work.',
            steps: [
                {
                    title: 'Tell Us About Your Project',
                    description:
                        'Share the location, scope, and result you have in mind.'
                },
                {
                    title: 'Site Evaluation & Estimate',
                    description:
                        'We review the conditions and prepare a clear project estimate.'
                },
                {
                    title: 'Preparation & Installation',
                    description:
                        'The site is prepared and the concrete work is completed with care.'
                },
                {
                    title: 'Final Review',
                    description:
                        'We walk through the finished work and close out the project.'
                }
            ]
        },

        area: {
            eyebrow: 'Proudly Serving',
            titleFirst: 'North Mississippi',
            titleSecond: '& surrounding areas.',
            description:
                'Have a project nearby? Send us your city or ZIP code and we will confirm availability for your location.',
            button: 'Check Availability',
            cities: [
                'Horn Lake',
                'Southaven',
                'Holly Springs',
                'Hernando',
                'Nesbit',
                'Olive Branch',
                'Eudora',
                'Tunica',
                'Senatobia',
                'Sardis',
                'Batesville',
                'Abbeville',
                'Oxford',
                'Sarah',
                'Water Valley',
                'Waterford'
            ]
        },

        form: {
            eyebrow: "Let's Build Something",
            titleFirst: 'Ready to turn your idea into',
            titleSecond: 'something solid?',
            description:
                'Tell us about your project. We will use this information to understand your needs and contact you about the next step.',
            freeEstimate: 'Free Estimates',
            note:
                'No pressure. Just a straightforward conversation about your project.',
            name: 'Full Name',
            namePlaceholder: 'Your name',
            phone: 'Phone Number',
            phonePlaceholder: '(000) 000-0000',
            email: 'Email Address',
            emailPlaceholder: 'you@email.com',
            location: 'City / ZIP Code',
            locationPlaceholder: 'Your project location',
            projectType: 'Project Type',
            selectType: 'Select one',
            residential: 'Residential',
            commercial: 'Commercial',
            service: 'Service Needed',
            selectService: 'Select a service',
            message: 'Tell Us About Your Project',
            messagePlaceholder: 'What would you like to build?',
            submit: 'Request My Free Estimate',
            sending: 'Sending Request...',
            success:
                'Thank you. Your request was sent successfully. We will contact you soon.',
            error:
                'The request could not be sent. Please try again or call us directly.'
        },

        footer: {
            slogan: 'Your vision. Built to last.',
            explore: 'Explore',
            serviceArea: 'Service Area',
            surroundingAreas: 'And surrounding areas',
            startProject: 'Start a Project',
            requestEstimate: 'Request an Estimate',
            checkAvailability: 'Check Availability',
            rights: 'All rights reserved.',
            closing: 'Your vision. Built to last.'
        },

        common: {
            callUs: 'Call Us'
        }
    },

    es: {
        language: {
            current: 'ES',
            changeTo: 'EN',
            label: 'Cambiar idioma a inglés'
        },

        navigation: {
            home: 'Inicio',
            about: 'Quiénes Somos',
            services: 'Servicios',
            projects: 'Nuestro Trabajo',
            process: 'Nuestro Proceso',
            area: 'Área de Servicio',
            contact: 'Contacto',
            estimate: 'Cotización Gratuita'
        },

        hero: {
            eyebrow: 'Concreto construido con propósito',
            titleFirst: 'Tu visión.',
            titleSecond: 'Construida para durar.',
            description:
                'Soluciones profesionales de concreto residencial y comercial en el norte de Mississippi, realizadas con cuidado, claridad y experiencia.',
            estimate: 'Solicita una Cotización',
            projects: 'Explora Nuestro Trabajo',
            trust: [
                'Proyectos Residenciales y Comerciales',
                'Cotizaciones Gratuitas',
                'Trabajo de Calidad',
                'Servicio en el Norte de Mississippi'
            ]
        },

        about: {
            section: 'Acerca de MMP Concrete LLC',
            eyebrow: 'Trabajo sólido. Respuestas claras.',
            titleFirst: 'Trabajo de concreto construido alrededor de',
            titleSecond: 'tu visión.',
            paragraphOne:
                'MMP Concrete LLC ofrece soluciones confiables de concreto residencial y comercial en todo el norte de Mississippi. Desde una banqueta hasta un piso comercial, realizamos cada proyecto con la misma atención al detalle.',
            paragraphTwo:
                'Nuestro objetivo es sencillo: comprender lo que necesitas, preparar correctamente el trabajo y entregar un acabado resistente y limpio que te genere confianza.'
        },

        mission: {
            eyebrow: 'Nuestra Misión',
            titleFirst: 'Construir correctamente.',
            titleSecond: 'Tratar bien a las personas.',
            values: [
                {
                    title: 'Calidad',
                    description:
                        'Preparación cuidadosa y atención a los detalles que producen resultados duraderos.'
                },
                {
                    title: 'Comunicación',
                    description:
                        'Expectativas claras y actualizaciones directas desde la cotización hasta la revisión final.'
                },
                {
                    title: 'Confiabilidad',
                    description:
                        'Un enfoque profesional centrado en tu propiedad, tiempos y objetivos.'
                }
            ]
        },

        services: {
            section: 'Lo que Construimos',
            eyebrow: 'Nuestros Servicios',
            titleFirst: 'Desde el primer colado hasta el',
            titleSecond: 'acabado final.',
            description:
                'Soluciones prácticas de concreto para hogares, negocios y proyectos personalizados de diferentes tamaños.',
            action: 'Consultar Este Servicio',
            items: [
                {
                    title: 'Entradas Vehiculares',
                    description:
                        'Entradas limpias y resistentes, diseñadas para el uso diario y una apariencia duradera.'
                },
                {
                    title: 'Patios',
                    description:
                        'Espacios exteriores diseñados para reuniones, descanso y convivencia.'
                },
                {
                    title: 'Andadores y Banquetas',
                    description:
                        'Caminos seguros y con acabado profesional que conectan tu propiedad.'
                },
                {
                    title: 'Losas de Concreto',
                    description:
                        'Losas correctamente preparadas para cobertizos, talleres, ampliaciones y construcciones.'
                },
                {
                    title: 'Pisos Comerciales',
                    description:
                        'Soluciones profesionales de concreto para las exigencias de espacios comerciales.'
                },
                {
                    title: 'Proyectos Personalizados',
                    description:
                        'Una solución práctica y personalizada para proyectos fuera de los diseños convencionales.'
                }
            ]
        },

        projects: {
            section: 'Proyectos Seleccionados',
            eyebrow: 'Construido en el Mundo Real',
            titleFirst: 'Trabajo que habla',
            titleSecond: 'por sí mismo.',
            description:
                'Explora una selección de la variedad, los acabados y el cuidado que aportamos a cada proyecto.',
            filters: {
                all: 'Todos',
                driveways: 'Entradas',
                patios: 'Patios',
                sidewalks: 'Banquetas',
                slabs: 'Losas',
                commercial: 'Comercial',
                other: 'Otros'
            },
            viewProject: 'Ver Proyecto',
            close: 'Cerrar',
            empty:
                'Actualmente no hay proyectos disponibles en esta categoría.'
        },

        process: {
            section: 'Nuestro Proceso',
            eyebrow: 'Claridad Desde el Primer Día',
            titleFirst: 'Un camino directo desde la idea hasta el',
            titleSecond: 'trabajo terminado.',
            steps: [
                {
                    title: 'Cuéntanos Sobre tu Proyecto',
                    description:
                        'Comparte la ubicación, alcance y resultado que tienes en mente.'
                },
                {
                    title: 'Evaluación y Cotización',
                    description:
                        'Revisamos las condiciones y preparamos una cotización clara.'
                },
                {
                    title: 'Preparación e Instalación',
                    description:
                        'Preparamos el área y realizamos cuidadosamente el trabajo de concreto.'
                },
                {
                    title: 'Revisión Final',
                    description:
                        'Revisamos contigo el trabajo terminado y concluimos el proyecto.'
                }
            ]
        },

        area: {
            eyebrow: 'Área de Cobertura',
            titleFirst: 'Norte de Mississippi',
            titleSecond: 'y zonas cercanas.',
            description:
                '¿Tienes un proyecto cerca? Envíanos tu ciudad o código postal y confirmaremos la disponibilidad en tu ubicación.',
            button: 'Consultar Disponibilidad',
            cities: [
                'Horn Lake',
                'Southaven',
                'Holly Springs',
                'Hernando',
                'Nesbit',
                'Olive Branch',
                'Eudora',
                'Tunica',
                'Senatobia',
                'Sardis',
                'Batesville',
                'Abbeville',
                'Oxford',
                'Sarah',
                'Water Valley',
                'Waterford'
            ]
        },

        form: {
            eyebrow: 'Construyamos Algo Juntos',
            titleFirst: '¿Listo para convertir tu idea en',
            titleSecond: 'algo sólido?',
            description:
                'Cuéntanos sobre tu proyecto. Utilizaremos esta información para conocer tus necesidades y comunicarnos contigo.',
            freeEstimate: 'Cotizaciones Gratuitas',
            note:
                'Sin presión. Solamente una conversación clara sobre tu proyecto.',
            name: 'Nombre Completo',
            namePlaceholder: 'Tu nombre',
            phone: 'Número Telefónico',
            phonePlaceholder: '(000) 000-0000',
            email: 'Correo Electrónico',
            emailPlaceholder: 'correo@ejemplo.com',
            location: 'Ciudad / Código Postal',
            locationPlaceholder: 'Ubicación del proyecto',
            projectType: 'Tipo de Proyecto',
            selectType: 'Selecciona una opción',
            residential: 'Residencial',
            commercial: 'Comercial',
            service: 'Servicio Requerido',
            selectService: 'Selecciona un servicio',
            message: 'Cuéntanos Sobre tu Proyecto',
            messagePlaceholder: '¿Qué te gustaría construir?',
            submit: 'Solicitar Cotización Gratuita',
            sending: 'Enviando Solicitud...',
            success:
                'Gracias. Tu solicitud fue enviada correctamente. Nos comunicaremos contigo pronto.',
            error:
                'No fue posible enviar la solicitud. Inténtalo nuevamente o llámanos directamente.'
        },

        footer: {
            slogan: 'Tu visión. Construida para durar.',
            explore: 'Explorar',
            serviceArea: 'Área de Servicio',
            surroundingAreas: 'Y zonas cercanas',
            startProject: 'Iniciar un Proyecto',
            requestEstimate: 'Solicitar Cotización',
            checkAvailability: 'Consultar Disponibilidad',
            rights: 'Todos los derechos reservados.',
            closing: 'Tu visión. Construida para durar.'
        },

        common: {
            callUs: 'Llámanos'
        }
    }
}

export default translations